/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardViewDataModal_sales = {
    readonly spoke: string;
    readonly spokeAcc: string;
    readonly email: string;
    readonly cellNumber: string;
    readonly isNull: boolean;
    readonly name: string;
    readonly key: string;
    readonly yesterdaysSalesToDate: number;
    readonly currentMonthToDate: number;
    readonly lastMonth: number;
    readonly lastMonthMonthToDate: number;
    readonly " $refType": "DashboardViewDataModal_sales";
};
export type DashboardViewDataModal_sales$data = DashboardViewDataModal_sales;
export type DashboardViewDataModal_sales$key = {
    readonly " $data"?: DashboardViewDataModal_sales$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardViewDataModal_sales">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardViewDataModal_sales",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spoke",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spokeAcc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cellNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNull",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "yesterdaysSalesToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentMonthToDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastMonthMonthToDate",
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReportSales",
  "abstractKey": null
};
(node as any).hash = 'da33b91bd06b67811702253982bc3316';
export default node;
